import {
    Grid,
    TextField,
    Dialog,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
    Paper,
    Card,
    Select,
    MenuItem
} from '@material-ui/core';
import {
    createStyles, makeStyles,
    Theme,
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Chip, styled } from "@mui/material";
import { Button } from '@material-ui/core';
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import './NewBooking.css'
import AddIcon from "@mui/icons-material/Add";
import AddMemberModal from "./AddMember";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import moment from "moment";
import OutlinedInput from "@mui/material/OutlinedInput";
import Loader from '../../Loader2'
import Box from "@mui/material/Box";
import {
    addUniqueCustomer,
    checkGeoFenchMapMyIndiaPilot,
    getTimeslots,
    getLeadsNew,
    getLeadDetails,
} from "../../../actions/OffLineSupportActions"
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },

        hoveItem: {
            cursor: "pointer",
        },

        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        root1: {
            // backgroundColor: "#fa4d83",

        },
        toolbar: {
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(4, 4),
            ...theme.mixins.toolbar,
        },
        contentTable: {
            padding: "20px 10px 10px 10px",
            background: "#ffffff",
            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        },
        content: {
            width: "100%",
            flexGrow: 21,
            marginTop: "70px",
        },
        slotContainer: {
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
        },
        slot: {
            width: "150px",
            height: "100px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            margin: "0.5rem",
        },
        selectedSlot: {
            width: "150px",
            height: "100px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
            cursor: "pointer",
            margin: "0.5rem",
        },
        buttonContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
    })
);


const BodyContainer = styled(Paper)`
    background-color: #F9FCFF;
    background: linear-gradient(147deg, #c3cbdc 0%, #edf1f4 74%);
    height: 100vh;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

interface Props {
    addUniqueCustomer: any;
    add_unique_customer: any;
    checkGeoFenchMapMyIndiaPilot: any;
    geoLoading: boolean;
    geoCheckCityId: String;
    getTimeslots: any;
    timeslots: any;
    getLeadsNew: any;
    get_leads_new: any;
    getLeadDetails: any;
    lead_details: any;


}
const StopsPlace: React.FC<Props> = ({
    addUniqueCustomer,
    add_unique_customer,
    checkGeoFenchMapMyIndiaPilot,
    geoLoading,
    geoCheckCityId,
    getTimeslots,
    timeslots,
    getLeadsNew,
    get_leads_new,
    getLeadDetails,
    lead_details,


}) => {
    const classes = useStyles();
    const { _id } = useParams<{ _id: string }>();
    const history = useHistory()
    const [search, setSearch] = useState<string>("");
    const handleSearch = (e: React.ChangeEvent<{ value: string }>) => {
        setSearch(e.target.value?.replace(/[^0-9]/g, "")?.slice(0, 10) as string);
    };
    const [mobNumErr, setMobNumErr] = useState<string>("");
    const [customer_phonenumber, setCustomer_phonenumber] = useState<String>("");
    const [customer_alternatenumber, setCustomer_alternatenumber] = useState<String>("");
    const [customer_whatsapppnumber, setCustomer_whatsapppnumber] = useState<String>("");
    const [customer_address, setCustomer_address] = useState<String>("");
    const [customer_email, setCustomer_email] = useState<String>("");
    const [passport, setPassport] = useState<String>("");
    const [deactiveInputs, setDeactivateInputs] = useState<boolean>(false);
    const [showName, setShowName] = useState<any>(0);
    const regex = /^[6-9]\d{9}$/;
    const [mobileValidation, setMobileValidation] = useState({
        customer_alternatenumber: true,
        customer_phonenumber: true,
        customer_whatsapppnumber: true,
    });
    const [lead_customer_phonenumber, setLeadCustomer_phonenumber] = useState<string>();
    const [lead_customer_whatsapppnumber, setLeadCustomer_whatsapppnumber] = useState<string>();
    const [timeSlots, setTimeSlots] = useState<Array<{ "available_slots": number }>>([]);
    const [selectedSlot, setSelectedSlot] = useState<Number>(0);
    const [apiCustomerRes, setApiCustomerRes] = useState<string>("");
    const [bookingForText, setBookingForText] = useState<string>("");
    const [editBookingForIndex, setEditBookingForIndex] = useState<number>(-1);
    const [allUHIDCustomer, setAllUHIDCustomer] = useState<any>([]);
    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: "50vh",
            },
        },
    };


    const verifyMobile = (type: any) => {
        const mobileRegEx = /^[6-9]\d{9}$/;
        if (
            type === "alternate" &&
            customer_alternatenumber &&
            !mobileRegEx.test(customer_alternatenumber.toString())
        ) {
            setMobileValidation((prev: any) => ({
                ...prev,
                customer_alternatenumber: false,
            }));
        }
        if (
            type === "whatsapp" &&
            customer_whatsapppnumber &&
            !mobileRegEx.test(customer_whatsapppnumber.toString())
        ) {
            setMobileValidation((prev: any) => ({
                ...prev,
                customer_whatsapppnumber: false,
            }));
        }
        if (
            type === "mobile" &&
            customer_phonenumber &&
            !mobileRegEx.test(customer_phonenumber.toString())
        ) {
            setMobileValidation((prev: any) => ({
                ...prev,
                customer_phonenumber: false,
            }));
        }
    };

    useEffect(() => {
        if (search.length) {
            if (regex.test(search)) {
                setMobNumErr("");
                setDeactivateInputs(true);
            } else {
                setMobNumErr("Please enter a valid mobile number");
                setDeactivateInputs(false);
            }
        } else {
            setMobNumErr("");
            setDeactivateInputs(false);
        }
    }, [search]);

    const hanldeBack = () => {
        history.push("/dashboard/os/create_booking")
    }

    const [openAddMemberModal, setOpenAddMemberModal] = useState<boolean>(false);

    const handleAddMemberModal = () => {
        setOpenAddMemberModal(true);
    };
    const [inputList, setInputList] = useState<any>([
        {
            customerId: "",
            customerDesignation: "",
            designation: "",
            customerName: "",
            customerAge: "",
            customerGender: "",
            customerPackage: [],
            customerAddOnPackage: [],
            customerTest: [],
            packagePrice: 0,
            dateOfBirth: "",
            is_prescribed: "",
            bookingFor: "",
            oldBookingFor: "",
            passport: "",
            aadhar: "",
            oldNameUHID: "",
            isSelectedMember: false,
            freeGlucoseFastingTestDisabled: false,
            freeGlucoseFastingRandomTestDisabled: false,
            freeHbA1cTestDisabled: false,
            lastBookingDate: "",
            previousBookedPackages: [],
            tubes: [],
        },
    ]);
    useEffect(() => {
        const selectedCustomer: any = [];
        allUHIDCustomer.map((data: any) => {
            if (data.isSelected) {
                selectedCustomer.push(data);
            }
        });
        if (selectedCustomer.length !== 0) {
            setInputList(selectedCustomer);
            setShowName(1);
        } else {
            setShowName(0);
        }
    }, [allUHIDCustomer]);


    const handleUHIDAddCustomer = (data: any, index: any) => {
        const list = [...allUHIDCustomer];
        list[index]["isSelected"] = true;
        setAllUHIDCustomer(list);
    };

    const handleUHIDRemoveCustomer = (data: any, index: any) => {
        const list = [...allUHIDCustomer];
        list[index]["isSelected"] = false;
        setAllUHIDCustomer(list);
    };

    const handleRemoveClick = (data: any, index: any) => {
        const indexOfUHID = allUHIDCustomer.findIndex(
            (item: any) => item.customerId === data?.customerId
        );

        if (indexOfUHID !== -1) {
            handleUHIDRemoveCustomer("data", indexOfUHID);
            handleClose();
        } else {
            const list = [...inputList];
            // handlePackage(index, []);

            list.splice(index, 1);
            setInputList(list);

        }
    };

    useEffect(() => {
        if (Object.keys(lead_details).length !== 0) {
            setCustomer_address(lead_details?.address);
            setLeadCustomer_phonenumber(lead_details?.content_number);
            setLeadCustomer_whatsapppnumber(lead_details?.whatsapp_contact);
        } else {
            setCustomer_address("");
            setLeadCustomer_phonenumber("");
            setLeadCustomer_whatsapppnumber("");
        }
    }, [lead_details]);

    useEffect(() => {
        if (search.length === 10 && mobNumErr === "") {
            let body = {
                search_by: "call_id",
                value: search,
            };
            (async () => {
                // await getLeadsNew(body, "number=true");
                await getLeadsNew(body, `mobile=${search}`);
            })();
        }
    }, [search, mobNumErr]);

    const [mobError, setMobError] = React.useState<string>("");
    const [selfExistsInLead, setSelfExistsInLead] = useState<boolean>(false);

    useEffect(() => {
        const allUHID: any = [];
        let tempPatientModal: boolean = false,
            tempApiCustomerRes = "";
        // setSelfExistsInLead(false);
        if (get_leads_new && get_leads_new.length > 0) {
            get_leads_new?.map((data: any) => {
                if (data?.booking_for === "self") {
                    setSelfExistsInLead(true);
                }
                allUHID.push({
                    customerId: data?.id,
                    lead: data?.lead,
                    customerDesignation:
                        data?.gender?.trim()?.toLowerCase() === "female" ||
                            data?.designation?.trim()?.toLowerCase() == "ms"
                            ? "Ms"
                            : "Mr",
                    designation:
                        data?.gender?.trim()?.toLowerCase() === "female" ||
                            data?.designation?.trim()?.toLowerCase() == "ms"
                            ? "Ms"
                            : "Mr",
                    customerName: data?.display_name,
                    customerAge: data?.age !== null ? data?.age : "",
                    customerGender:
                        data?.gender?.trim()?.toLowerCase() === "female" ||
                            data?.designation?.trim()?.toLowerCase() == "ms"
                            ? "female"
                            : "male",
                    customerPackage: [],
                    customerAddOnPackage: [],
                    customerTest: [],
                    packagePrice: 0,
                    dateOfBirth: data?.dob !== null ? data?.dob : "",
                    isSelected: false,
                    is_prescribed: "",
                    bookingFor: data?.booking_for,
                    oldBookingFor: data?.booking_for,
                    passport: "",
                    aadhar: "",
                    oldNameUHID: data?.display_name,
                    isSelectedMember: false,
                    freeGlucoseFastingTestDisabled: false,
                    freeGlucoseFastingRandomTestDisabled: false,
                    freeHbA1cTestDisabled: false,
                    lastBookingDate: data?.last_booking_created_date
                        ? moment(data?.last_booking_created_date).format("Do MMMM, YYYY")
                        : "NA",
                    previousBookedPackages: data?.last_packages_booked
                        ? data?.last_packages_booked
                        : [],
                });
            });
            tempPatientModal = true;
        } else {
            if (search.length === 10 && mobError === "") {
                tempApiCustomerRes =
                    "There is no any member, please add member through Add New Button.";
            } else {
                tempApiCustomerRes = "";
            }
        }
        setAllUHIDCustomer(allUHID);
        setOpen(tempPatientModal);
        setApiCustomerRes(tempApiCustomerRes);
    }, [get_leads_new]);

    useEffect(() => {
        if (search.length > 0) {
            var regex = /^[6-9]\d{9}$/;
            var output: any = search.match(regex);
            if (output?.length > 0 && String(output[0]).length === 10) {
                setCustomer_phonenumber(String(output[0]));
            }
        }
    }, [search]);



    console.log(inputList, "inputList")
    return (
        <BodyContainer  className={classes.content} style={{marginTop:"60px",display:"flex"}}>
            <Grid container spacing={2} style={{ marginLeft: "5px", marginTop: "80px" }}>
                <Grid item xs={12} md={2}>
                    <Button
                        variant="contained"
                        onClick={hanldeBack}
                    >
                        Back
                    </Button>
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField
                        fullWidth
                        id="mobileNumberId"
                        label="Search by Phone Number"
                        variant="outlined"
                        className='input'
                        value={search}
                        onChange={(e) => handleSearch(e)}
                        error={Boolean(mobNumErr)}
                        helperText={mobNumErr}
                        inputProps={{
                            maxLength: 10,
                            inputMode: "numeric",
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={2} >
                    <Button
                        variant="contained"
                        color="primary"
                    >
                        Search
                    </Button>
                </Grid>
                <Grid item xs={12} md={2}>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<AddIcon />}
                        // disabled={
                        //     search.length === 10 && mobNumErr === "" ? false : true
                        // }
                        onClick={handleAddMemberModal}
                    >
                        Add New
                    </Button>
                </Grid>
                <Grid
                    container
                    spacing={3}
                    style={
                        apiCustomerRes
                            ? {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "red",
                                padding: "5px",
                            }
                            : { display: "none" }
                    }
                >
                    <Grid
                        item
                        xs={12}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {apiCustomerRes}
                    </Grid>
                </Grid>
                <Grid container spacing={3} style={{ marginTop: "10px" }}>
                    <Grid item xs={12} md={12}>
                        <Select
                            className="input"
                            name="designation"
                            variant="outlined"
                            value={showName === 0 ? [] : inputList}
                            onChange={(e) => e.stopPropagation()}
                            open={open}
                            onClose={handleClose}
                            onOpen={handleOpen}
                            multiple
                            fullWidth
                            input={
                                <OutlinedInput id="select-multiple-patient" label="Chip" />
                            }
                            renderValue={(selected: any) => (
                                <Box sx={{ display: "flex", gap: 0.5 }}>
                                    {selected.map((value: any) => (
                                        <Chip
                                            key={value?.customerName}
                                            label={value?.customerName}
                                        />
                                    ))}
                                </Box>
                            )}
                            MenuProps={MenuProps}
                            disabled={allUHIDCustomer?.length === 0 || search.length < 10}
                        >
                            {allUHIDCustomer &&
                                allUHIDCustomer.length > 0 &&
                                allUHIDCustomer.map((data: any, index: any) => (
                                    <MenuItem
                                        key={data?.customerId}
                                        value={data?.customerId}
                                        onClick={handleOpen}
                                        style={{
                                            borderBottom: "1px solid #d0cccc",
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "default",
                                        }}
                                    >
                                        <div style={{ display: "flex", width: "100%" }}>
                                            <h6 style={{ minWidth: "30px", fontWeight: "300" }}>
                                                {index + 1 + "-"}
                                            </h6>
                                            <h6 style={{ minWidth: "30px", fontWeight: "300" }}>
                                                {data?.customerDesignation}
                                            </h6>
                                            <h5 style={{ minWidth: "60%", fontWeight: "300" }}>
                                                <h6>{data?.customerName}</h6>
                                            </h5>
                                            {/* Hide customerGender on small screens */}
                                            {data?.isSelected ? (
                                                <Button
                                                    style={{ backgroundColor: "red", color: "white" }}
                                                    onClick={() => {
                                                        handleUHIDRemoveCustomer(data, index);
                                                    }}
                                                >
                                                    REMOVE
                                                </Button>
                                            ) : (
                                                <Button
                                                    style={{ background: "green", color: "white" }}
                                                    onClick={() => handleUHIDAddCustomer(data, index)}
                                                >
                                                    ADD
                                                </Button>
                                            )}
                                        </div>
                                        <div
                                            id="hello"
                                            style={{
                                                width: "100%",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                paddingLeft: "5px",
                                            }}
                                        >
                                            {editBookingForIndex === index ? (
                                                <Select
                                                    className="input"
                                                    name="bookingForText"
                                                    variant="outlined"
                                                    value={bookingForText}
                                                    style={{
                                                        width: "100%",
                                                        margin: "0",
                                                    }}
                                                    onChange={(e) =>
                                                        setBookingForText(e.target.value as string)
                                                    }
                                                >
                                                    <MenuItem
                                                        value="self"
                                                        disabled={selfExistsInLead}
                                                    >
                                                        Self
                                                    </MenuItem>
                                                    <MenuItem value="father">Father</MenuItem>
                                                    <MenuItem value="mother">Mother</MenuItem>
                                                    <MenuItem value="son">Son</MenuItem>
                                                    <MenuItem value="daughter">Daughter</MenuItem>
                                                    <MenuItem value="spouse">Spouse</MenuItem>
                                                    <MenuItem value="grandparents">
                                                        Grandparents
                                                    </MenuItem>
                                                    <MenuItem value="siblings">Siblings</MenuItem>
                                                    <MenuItem value="in-laws">In-laws</MenuItem>
                                                    <MenuItem value="other">Others</MenuItem>
                                                </Select>
                                            ) : (
                                                <h6 style={{ minWidth: "100%" }}></h6>
                                            )}
                                        </div>
                                    </MenuItem>
                                ))}
                        </Select>
                    </Grid>
                </Grid>
                {/* main booking page  */}
                <Grid xs={12}>
                    <div
                        className={classes.contentTable}
                        style={
                            openAddMemberModal
                                ? { filter: "blur(5px" }
                                : { filter: "blur(0px" }
                        }
                    >
                        <form>
                            {/* add new section  */}
                            <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="flex-end"
                                spacing={2}
                                style={{ margin: "1rem auto", background: "#a5c0c9" }}
                            >
                                <Grid item md={2} xs={12}>
                                    <p>Mobile Number*</p>
                                    {lead_customer_phonenumber ? (
                                        <TextField
                                            className="input"
                                            name="customer_phonenumber"
                                            disabled={lead_customer_phonenumber ? true : false}
                                            value={"XXXXXXXXXX"}
                                            placeholder="Mobile Number"
                                            variant="outlined"
                                            style={{ margin: "0", width: "100%" }}
                                        />
                                    ) : (
                                        <TextField
                                            className="input"
                                            name="customer_phonenumber"
                                            disabled={lead_customer_phonenumber ? true : false}
                                            value={customer_phonenumber}
                                            placeholder="Mobile Number"
                                            variant="outlined"
                                            style={{ margin: "0", width: "100%" }}
                                            onChange={(e) =>
                                                setCustomer_phonenumber(e.target.value as String)
                                            }
                                            type="number"
                                            onWheel={(e: any) => e.target.blur()}
                                            onInput={(e: any) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value))
                                                    .toString()
                                                    .slice(0, 10);
                                            }}
                                            onBlur={() => verifyMobile("mobile")}
                                            onFocus={() => {
                                                setMobileValidation((prev: any) => ({
                                                    ...prev,
                                                    customer_phonenumber: true,
                                                }));
                                            }}
                                            helperText={
                                                !mobileValidation.customer_phonenumber &&
                                                "Incorrect Phone Number"
                                            }
                                            required
                                        />
                                    )}
                                </Grid>
                                <Grid item md={2} xs={12}>
                                    <p>Alternate Mobile Number</p>
                                    {lead_customer_phonenumber ? (
                                        <TextField
                                            className="input"
                                            name="customer_alternatenumber"
                                            disabled={lead_customer_phonenumber ? true : false}
                                            value={"XXXXXXXXXX"}
                                            placeholder="Alternate Mobile Number"
                                            variant="outlined"
                                            style={{ margin: "0", width: "100%" }}
                                        />
                                    ) : (
                                        <TextField
                                            className="input"
                                            name="customer_alternatenumber"
                                            type="number"
                                            onWheel={(e: any) => e.target.blur()}
                                            onInput={(e: any) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value))
                                                    .toString()
                                                    .slice(0, 10);
                                            }}
                                            disabled={lead_customer_phonenumber ? true : false}
                                            value={customer_alternatenumber}
                                            placeholder="Alternate Mobile Number"
                                            variant="outlined"
                                            style={{ margin: "0", width: "100%" }}
                                            onChange={(e) =>
                                                setCustomer_alternatenumber(e.target.value as String)
                                            }
                                            onBlur={() => verifyMobile("alternate")}
                                            onFocus={() => {
                                                setMobileValidation((prev: any) => ({
                                                    ...prev,
                                                    customer_alternatenumber: true,
                                                }));
                                            }}
                                            helperText={
                                                !mobileValidation.customer_alternatenumber &&
                                                "Incorrect Phone Number"
                                            }
                                        />
                                    )}
                                </Grid>
                                <Grid item md={2} xs={12}>
                                    <p>Whatsapp Number</p>
                                    {lead_customer_whatsapppnumber ? (
                                        <TextField
                                            className="input"
                                            name="customer_whatsapppnumber"
                                            placeholder="Whatsapp Number"
                                            disabled={lead_customer_whatsapppnumber ? true : false}
                                            value={"XXXXXXXXXX"}
                                            variant="outlined"
                                            style={{ margin: "0", width: "100%" }}
                                        />
                                    ) : (
                                        <TextField
                                            className="input"
                                            name="customer_whatsapppnumber"
                                            type="number"
                                            onWheel={(e: any) => e.target.blur()}
                                            onInput={(e: any) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value))
                                                    .toString()
                                                    .slice(0, 10);
                                            }}
                                            placeholder="Whatsapp Number"
                                            // disabled={lead_customer_whatsapppnumber ? true : false}
                                            value={customer_whatsapppnumber}
                                            variant="outlined"
                                            style={{ margin: "0", width: "100%" }}
                                            onChange={(e) =>
                                                setCustomer_whatsapppnumber(e.target.value as String)
                                            }
                                            onBlur={() => verifyMobile("whatsapp")}
                                            onFocus={() => {
                                                setMobileValidation((prev: any) => ({
                                                    ...prev,
                                                    customer_whatsapppnumber: true,
                                                }));
                                            }}
                                            helperText={
                                                !mobileValidation.customer_whatsapppnumber &&
                                                "Incorrect Whatsapp Number"
                                            }
                                        />
                                    )}
                                </Grid>
                                <Grid item md={3} xs={12}>
                                    <p>Email</p>
                                    <TextField
                                        className="input"
                                        name="customer_email"
                                        type="email"
                                        placeholder="customer.reports@redcliffelabs.com"
                                        value={customer_email}
                                        variant="outlined"
                                        style={{ margin: "0", width: "100%" }}
                                        onChange={(e) => setCustomer_email(e.target.value as String)}
                                    />
                                </Grid>
                                <Grid item md={3} xs={12}>
                                    <p>Passport Number</p>
                                    <TextField
                                        className="input"
                                        name="passport"
                                        type="text"
                                        placeholder="Enter Passport Number"
                                        value={passport}
                                        variant="outlined"
                                        style={{ margin: "0", width: "100%" }}
                                        onChange={(e) => setPassport(e.target.value as String)}
                                    />
                                </Grid>

                            </Grid>
                            {/* add new section closed  */}

                            {/* patient details  */}
                            <Grid
                                container
                                spacing={2}
                                direction="row"
                                alignItems="flex-end"
                                style={{ margin: "1rem auto", background: "#0e3f6c" }}
                            >
                                {inputList.length > 0 &&
                                    inputList.map((x: any, index: number) => {
                                        return (
                                            <>
                                                <TableContainer
                                                    key={x.customerId}
                                                    component={Paper}
                                                    className={classes.tableContainer}
                                                    style={
                                                        index % 2 === 0
                                                            ? { background: "#81ecec", margin: "10px 0" }
                                                            : { background: "#dfe6e9", margin: "10px 0" }
                                                    }
                                                >
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow style={{ background: "#636e72" }}>
                                                                <TableCell
                                                                    style={{ fontWeight: "bold", color: "#fff" }}
                                                                >
                                                                    Remove
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{ fontWeight: "bold", color: "#fff" }}
                                                                >
                                                                    UHID
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{ fontWeight: "bold", color: "#fff" }}
                                                                >
                                                                    Patient Name
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{ fontWeight: "bold", color: "#fff" }}
                                                                >
                                                                    Age/DOB
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{ fontWeight: "bold", color: "#fff" }}
                                                                >
                                                                    Gender
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{ fontWeight: "bold", color: "#fff" }}
                                                                >
                                                                    Booking For
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableRow key={index}>
                                                                <TableCell>
                                                                    {inputList.length !== 1 ? (
                                                                        <HighlightOffIcon
                                                                            style={{
                                                                                height: "40px",
                                                                                width: "40px",
                                                                                borderRadius: "50%",
                                                                            }}
                                                                            onClick={() =>
                                                                                handleRemoveClick(x, index)
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        "N/A"
                                                                    )}
                                                                </TableCell>
                                                                <TableCell>{x.customerId || "N/A"}</TableCell>
                                                                <TableCell>
                                                                    {x.designation + " " + x.customerName}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {x.dateOfBirth
                                                                        ? moment(x.dateOfBirth).format("DD-MM-YYYY")
                                                                        : x.customerAge
                                                                            ? x.customerAge
                                                                            : "N/A"}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {x.customerGender === "male"
                                                                        ? "Male"
                                                                        : x.customerGender === "female"
                                                                            ? "Female"
                                                                            : "N/A" || "N/A"}
                                                                </TableCell>
                                                                <TableCell>{x.bookingFor || "N/A"}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </>
                                        );
                                    })}
                            </Grid >

                            <Grid
                                container
                                spacing={3}
                                direction="row"
                                justify="center"
                                alignItems="center"
                                style={{ margin: "1rem auto" }}
                            >
                                <Grid item xs={12} md={5}>
                                    <Card
                                        className="samplecollect"
                                        style={{ overflow: "auto", minHeight: "500px" }}
                                    >
                                        <p style={{ marginBottom: "1rem" }}>Sample Collection Time</p>
                                        {geoLoading ? (
                                            <Loader />
                                        ) : (
                                            <div className={classes.slotContainer}>
                                                {String(geoCheckCityId)?.length > 0
                                                    ? timeslots &&
                                                    timeslots?.results &&
                                                    timeslots.results.length > 0 &&
                                                    timeslots.results.map((slot: any) => {
                                                        return (
                                                            <Card
                                                                key={slot.id}
                                                                className={
                                                                    slot.id === selectedSlot
                                                                        ? classes.selectedSlot
                                                                        : classes.slot
                                                                }
                                                                onClick={() => setSelectedSlot(slot.id as Number)}
                                                            >
                                                                <p
                                                                    style={{
                                                                        textAlign: "center",
                                                                        color: "black",
                                                                        fontSize: "14px",
                                                                    }}
                                                                >
                                                                    {slot.start_time}-{slot.end_time}
                                                                </p>
                                                                <p
                                                                    style={{ textAlign: "center", color: "green" }}
                                                                ></p>
                                                            </Card>
                                                        );
                                                    })
                                                    : timeslots &&
                                                    timeslots?.results &&
                                                    timeslots.results.length > 0 &&
                                                    timeslots.results.map((slot: any) => {
                                                        return (
                                                            <Card
                                                                key={slot.id}
                                                                className={
                                                                    slot.id === selectedSlot
                                                                        ? classes.selectedSlot
                                                                        : classes.slot
                                                                }
                                                                onClick={() => setSelectedSlot(slot.id as Number)}
                                                            >
                                                                <p
                                                                    style={{
                                                                        textAlign: "center",
                                                                        color: "black",
                                                                        fontSize: "14px",
                                                                    }}
                                                                >
                                                                    {slot.start_time}-{slot.end_time}
                                                                </p>
                                                                <p
                                                                    style={{ textAlign: "center", color: "green" }}
                                                                ></p>
                                                            </Card>
                                                        );
                                                    })}
                                                {timeSlots !== undefined && timeSlots.length === 0 ? (
                                                    <p style={{ color: "red" }}>
                                                        "Time Slot is not Active in this Area"
                                                    </p>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        )}
                                    </Card>
                                </Grid>
                                <Grid item xs={12} md={7} style={{ padding: "10px" }}>
                                    <div className="price-details-new-bookings">
                                        <table style={{ width: "100%", margin: "0" }}>
                                            <thead>
                                                <tr>
                                                    <td className="cell" align="center">
                                                        S No.
                                                    </td>
                                                    <td className="cell" align="center">
                                                        Name
                                                    </td>
                                                    <td className="cell" align="center">
                                                        Package
                                                    </td>
                                                    <td className="cell" align="center">
                                                        Price
                                                    </td>
                                                </tr>
                                            </thead>

                                        </table>
                                    </div>
                                </Grid>
                            </Grid>

                            <div className={classes.buttonContainer}>
                                <Button
                                    type="submit"
                                    color="primary"
                                    variant="contained"
                                    style={{ marginLeft: "1rem", marginBottom: "20px" }}
                                >
                                    Proceed for booking
                                </Button>
                            </div>
                        </form>
                    </div>
                </Grid>
                {/* main booking page end  */}
            </Grid>
            <hr />
            {openAddMemberModal && !Boolean(mobNumErr) && search.length === 10 && (
                <Dialog open={openAddMemberModal} fullWidth maxWidth="lg">
                    <AddMemberModal
                        openAddMemberModal={openAddMemberModal}
                        setOpenAddMemberModal={setOpenAddMemberModal}
                        leadId={get_leads_new?.id}
                        search={search}
                    />
                </Dialog>
            )}
        </BodyContainer>
    );
};
const mapStateToProps = (state: any) => ({
    add_unique_customer: state.OffLineSupporteReducer.add_unique_customer,
    geoLoading: state.OffLineSupporteReducer.geoLoading,
    geoCheckCityId: state.OffLineSupporteReducer.geoCheckCityId,
    timeslots: state.OffLineSupporteReducer.timeslots,
    get_leads_new: state.OffLineSupporteReducer.get_leads_new,
    lead_details: state.OffLineSupporteReducer.lead_details,
});
export default connect(mapStateToProps, {
    addUniqueCustomer,
    checkGeoFenchMapMyIndiaPilot,
    getTimeslots,
    getLeadsNew,
    getLeadDetails

})(StopsPlace);
